module.exports = __webpack_public_path__ + "static/media/hasmodel.492c7112.png";